import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import cochin from './cochin.png';
import Navbar from '../../components/navbar/index';
import Footer from '../../components/Footer/Footer';
import Pagination from '@mui/material/Pagination';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const blogs = [
  { id: 1, date: '2025-12-10', title: "Older Blog from 2025", excerpt: "This blog was uploaded in 2025 ..." },
  { id: 2, date: '2026-03-10', title: "Blog from March 10, 2026", excerpt: "This blog was uploaded on March 10, 2026 ..." },
  { id: 3, date: '2026-03-18', title: "Latest Blog from March 18, 2026", excerpt: "This blog was uploaded on March 18, 2026 ..." },
];

export default function Blog() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Sort blogs by date in descending order (newest first)
  // Convert string dates to Date objects for proper comparison
  const sortedBlogs = [...blogs].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA; // Descending order (newest first)
  });

  // Log to verify sorting
  console.log('Sorted blogs:', sortedBlogs.map(blog => ({
    title: blog.title,
    date: blog.date,
    dateObj: new Date(blog.date)
  })));

  return (
    <>
      <Navbar />
      <Typography variant="h3" component="h2" sx={{ textAlign: 'center' }}>
        Blog/News
      </Typography>
      <Typography sx={{ textAlign: 'center' }}>
        <p>Investing in the unlisted market can offer unique opportunities for investors looking to diversify their portfolio and potentially earn significant returns.</p>
      </Typography>

      <div style={{ textAlign: 'center' }}>
        <TextField id="outlined-basic" label="Search..." variant="outlined" sx={{ width: "50rem", height: "1rem" }} />
      </div>

      <Box sx={{ margin: "5rem 0rem 2rem 1rem", display: "flex", flexWrap: "wrap", justifyContent: "space-evenly" }}>
        {sortedBlogs.map((blog) => (
          <Card key={blog.id} sx={{ maxWidth: 375, height: 600, margin: "1rem 0rem 0rem 0rem" }}>
            <CardActionArea>
              <CardMedia
                sx={{ objectFit: "fill" }}
                component="img"
                height="375"
                image={cochin}
                alt="blog image"
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  {new Date(blog.date).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
                </Typography>
                <Typography gutterBottom variant="h5" component="div" sx={{
                  fontSize: "large", fontWeight: 600, '&:hover': { color: "green" }
                }}>
                  {blog.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {blog.excerpt}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>

      <Pagination count={10} variant="outlined" shape="rounded" sx={{ margin: "2rem 0rem 2rem 28rem" }} />
      <Footer />
    </>
  )
}